import { useEffect } from 'react';

export function useEqualHeightsByClass(classNames: any[] = []) {
  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => matchHeights());

    function matchHeights() {
      classNames.forEach(className => {
        const elements = document.querySelectorAll<HTMLElement>(`.${className}`);
        let maxHeight = 0;

        // Reset to auto to recalculate
        elements.forEach(el => {
          el.style.height = 'auto';
        });

        elements.forEach(el => {
          maxHeight = Math.max(maxHeight, el.offsetHeight);
        });

        elements.forEach(el => {
          el.style.height = `${maxHeight}px`;
        });
      });
    }

    if (!window || !document) return;

    // Initial match
    matchHeights();
    window.addEventListener('resize', matchHeights);

    // Observe dynamic changes
    classNames.forEach(className => {
      document.querySelectorAll(`.${className}`).forEach(el => {
        resizeObserver.observe(el);
      });
    });

    return () => {
      window.removeEventListener('resize', matchHeights);
      resizeObserver.disconnect();
    };
  }, [classNames]);
}
